import React from 'react';
import { PageComponentProps } from 'shared/interface/globalInterface';
import Triage from 'pages/DashboardB/DashboardTriage/Triage';

const SalesTriage: React.FC<PageComponentProps> = ({ ...props }) => {
  return (
    <Triage
      leftTriageCard={{ title: 'Broker portal', icon: 'productSelection' }}
      rightTriageCard={{ title: 'LiveMore portal', icon: 'account' }}
      {...props}
    />
  );
};

export default SalesTriage;
